// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FinishCallButton__icon-db0408 {
  fill: var(--addition-50);
  width: 24px;
  height: 24px;
}

.FinishCallButton__popover-f197e2 {
  background-color: var(--light-10-addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallActionsPanel/FinishCallButton/FinishCallButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAGA;EACE,8CAAA;AAAF","sourcesContent":[".icon {\n  fill: var(--addition-50);\n  width: 24px;\n  height: 24px;\n}\n\n\n.popover {\n  background-color: var(--light-10-addition-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `FinishCallButton__icon-db0408`,
	"popover": `FinishCallButton__popover-f197e2`
};
module.exports = ___CSS_LOADER_EXPORT___;
